import React, { Component } from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Select } from '../shared/styled-components';
const { podcastCategories } = require('../../../../../server/scripts/utils.js')();

const extractCategories = (source, prefix = false) => {
  return Object.keys(source).map((key, index) => {
    const { name = '', subCategories = {} } = source[key];
    if (isEmpty(subCategories)) {
      const value = prefix ? `${prefix} - ${name}` : name;
      return <option value={value} key={index}>{name}</option>;
    }

    return (
      <optgroup label={name} key={index}>
        {extractCategories(subCategories, name)}
      </optgroup>
    );
  });
};

const ItunesCategoriesOptions = extractCategories(podcastCategories);

class ItunesCategories extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.value === nextProps.value) {
      return false;
    }

    return true;
  }

  render() {
    const { value, onChange } = this.props;

    return (
      <InputSelect
        value={value}
        onChange={onChange}>
        <option value=""></option>
        {ItunesCategoriesOptions}
      </InputSelect>
    );
  }
}

const InputSelect = styled(Select)`
  font-size: 1.6rem;
  border-radius: 4px;
  margin-bottom: 0;
`;

export default ItunesCategories;
